import React from 'react';
import Container from '@material-ui/core/Container';

interface Props {
    children: any;
}

export const PublicLayout = ({ children }: Props) => <Container maxWidth="xs">{children}</Container>;
